// extracted by mini-css-extract-plugin
export default {"container":"SimpleHeader_container__RqAuO","goBack":"SimpleHeader_goBack__xpEmv","text":"SimpleHeader_text__Gl6aV"};